<div class="choiceCard" [class.noAccentEdge]="!showAccentEdge" [class.selected]="selected" [class.soldOut]="soldOut" [class.interactive]="interactive" [attr.role]="interactive ? 'button' : null" [attr.tabindex]="interactive ? 0 : null" [attr.aria-pressed]="interactive ? selected : null" (click)="onActivate($event)" (keydown.enter)="onActivate($event)" (keydown.space)="onActivate($event)">
  @if (eyebrow) {
    <div class="choiceCardEyebrow">
      <span>{{ eyebrow }}</span>
    </div>
  }
  @if (showHeader) {
    <div class="choiceCardHeader">
      <div class="choiceCardHeading">
        <div class="choiceCardTitle"><ng-content select="[cardTitle]"></ng-content></div>
        <div class="choiceCardPrice"><ng-content select="[cardPrice]"></ng-content></div>
      </div>
      <div class="choiceCardAside">
        <ng-content select="[cardAside]"></ng-content>
        @if (selectable && !soldOut) {
          <span class="choiceCardCheck" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            </svg>
          </span>
        }
      </div>
    </div>
  }
  <div class="choiceCardDescription"><ng-content select="[cardDescription]"></ng-content></div>
  @if (soldOut || offer || showRemaining) {
    <div class="choiceCardBadges">
      @if (soldOut) {
        <span class="choiceBadge danger">{{ soldOutLabel }}</span>
      }
      @if (offer) {
        <span class="choiceBadge offer">{{ offer }}</span>
      }
      @if (showRemaining) {
        <span class="choiceBadge">{{ 'TIME_SLOTS.AVAILABLE_TICKETS' | translate }} {{ remaining }}</span>
      }
    </div>
  }
  <div class="choiceCardRows" [class.separated]="showHeader"><ng-content></ng-content></div>
</div>
